import { render, staticRenderFns } from "./UserBanking.vue?vue&type=template&id=c3a9c06a&scoped=true"
import script from "./UserBanking.vue?vue&type=script&lang=js"
export * from "./UserBanking.vue?vue&type=script&lang=js"
import style0 from "./UserBanking.vue?vue&type=style&index=0&id=c3a9c06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a9c06a",
  null
  
)

export default component.exports